const trimTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');

const unauthorizedSubscribers = new Set();

export const apiBase = () => trimTrailingSlash(process.env.REACT_APP_API_URL || '/api');

export const gfProxyBase = () => trimTrailingSlash(process.env.GF_PROXY_URL || apiBase());

export const apiUrl = (path = '') => {
    if (/^https?:\/\//i.test(path)) {
        return path;
    }
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `${apiBase()}${normalizedPath}`;
};

export const subscribeToUnauthorizedResponses = (listener) => {
    unauthorizedSubscribers.add(listener);
    return () => unauthorizedSubscribers.delete(listener);
};

export const apiFetch = async (path, options = {}) => {
    const { headers, json, skipSessionCheck = false, ...rest } = options;
    const nextHeaders = new Headers(headers || {});
    const fetchOptions = {
        ...rest,
        credentials: 'include',
        headers: nextHeaders,
    };

    if (json !== undefined) {
        if (!nextHeaders.has('Content-Type')) {
            nextHeaders.set('Content-Type', 'application/json');
        }
        fetchOptions.body = JSON.stringify(json);
    }

    const response = await fetch(apiUrl(path), fetchOptions);
    if (response.status === 401 && !skipSessionCheck) {
        unauthorizedSubscribers.forEach((listener) => listener(response, path));
    }
    return response;
};

export const readErrorMessage = async (response, fallback) => {
    try {
        const data = await response.json();
        return data?.error || data?.message || fallback;
    } catch {
        return fallback;
    }
};

export const sanitizeAuthUser = (value) => {
    if (!value || typeof value !== 'object') {
        return value;
    }

    const safeValue = { ...value };
    delete safeValue.token;
    delete safeValue.access_token;
    delete safeValue.id_token;
    delete safeValue.refresh_token;

    if (Array.isArray(safeValue.organizations)) {
        safeValue.organizations = safeValue.organizations.map((organization) => {
            if (!organization || typeof organization !== 'object') return organization;
            const safeOrganization = { ...organization };
            delete safeOrganization.token;
            delete safeOrganization.access_token;
            delete safeOrganization.id_token;
            delete safeOrganization.refresh_token;
            return safeOrganization;
        });
    }

    return safeValue;
};
